import { useQuery } from 'react-query';

import { getWidgetData as queryFn } from 'api/endPoints/getWidgetData';
import { QueryKeys } from 'api/queryKeys';

import { IFilter } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import { IPhasePerformanceContracts } from 'components/widgets/PhasePerformanceChart/PhasePerformance.types';

export const useQueryPhasePerformanceGetContracts = (params: QueryParams, endpoint: string) => {
    return useQuery<QueryFnResponse, QueryError, QueryResponse, [QueryKeys, unknown]>({
        queryKey: ['getMappedContracts', params],
        queryFn: () => queryFn(params, endpoint),
        enabled: Boolean(params.template_id),
    });
};

export interface QueryParams {
    template_id?: number;
    filter: {
        filters: IFilter[];
    };
}

export interface QueryFnResponse {
    mapped_contracts: IPhasePerformanceContracts[];
    phase_performance_breakdown_info: IToolTip;
    phase_performance_chart_info: IToolTip;
}

type QueryResponse = QueryFnResponse & {};
